export default {
  '作业列表':'作业列表',
  '请选择班级':'请选择班级',
  '作业标题、发布人模糊搜索':'作业标题、发布人模糊搜索',
  '发布作业':'发布作业',

  '到':'到',
  '提前结束':'提前结束',
  '作业标题':'作业标题',
  '接收班级':'接收班级',
  '发布人':'发布人',
  '作业周期':'作业周期',
  '确认要删除{workName}吗？':'确认要删除{workName}吗？',

  '删除后，无法查看该作业！':'删除后，无法查看该作业！',
  '{workName}删除成功！':'{workName}删除成功！',
  '确认要提前结束{workName}吗？':'确认要提前结束{workName}吗？',
  '结束后，用户将不能继续参与作业！':'结束后，用户将不能继续参与作业！',
  '{workName}提前终止成功！':'{workName}提前终止成功！',

  '编辑作业':'编辑作业',
  '查看作业':'查看作业',
  '作业详情':'作业详情',
  '作业内容':'作业内容',
  '详情':'详情',
  '明细':'明细',
  '数据':'数据',
  '发布作业':'发布作业',
  '填写基本信息':'填写基本信息',
  '配置作业内容':'配置作业内容',
  '基础信息':'基础信息',
  '作业名称':'作业名称',
  '请输入作业名称':'请输入作业名称',
  '周期':'周期',
  '范围':'范围',
  '请选择周期':'请选择周期',
  '请选择范围':'请选择范围',

  '配置运动项目':'配置运动项目',
  '每天重复':'每天重复',
  '每周重复':'每周重复',
  '布置方式':'布置方式',
  '增加项目':'增加项目',
  '选择项目':'选择项目',
  '运动方式':'运动方式',
  '支持特殊项目':'支持特殊项目',
  '强度':'强度',
  '分':'分',
  '至':'至',
  '秒':'秒',
  '组数':'组数',
  '组':'组',

  '项目名':'项目名',
  '运动强度':'运动强度',
  '周一':'周一',
  '周二':'周二',
  '周三':'周三',
  '周四':'周四',
  '周五':'周五',
  '周六':'周六',
  '周日':'周日',
  '热身':'热身',
  '核心':'核心',
  '拉伸':'拉伸',

  '请选择布置方式':'请选择布置方式',
  '请选择应用终端':'请选择应用终端',
  '项目列表不能为空':'项目列表不能为空',
  '作业保存成功！':'作业保存成功！',
  '编辑项目':'编辑项目',
  '新增项目':'新增项目',
  '请选择运动项目':'请选择运动项目',
  '请填写运动强度':'请填写运动强度',
  '运动强度填写错误':'运动强度填写错误',
  '确认要删除运动项目【{sportSkuName}】吗？':'确认要删除运动项目【{sportSkuName}】吗？',
  '删除成功!':'删除成功!',

  '确认要返回吗？':'确认要返回吗？',
  '返回后，页面数据不做保存':'返回后，页面数据不做保存!',

  // 数据页相关
  '作业班级数据':'作业班级数据',
  '日期':'日期',
  '班级概况':'班级概况',
  '参与率':'参与率',
  '打卡率':'打卡率',
  '达标率':'达标率',
  '班级详情':'班级详情',
  '打卡情况':'打卡情况',
  '达标情况':'达标情况',
  '请输入姓名或学籍号':'请输入姓名或学籍号',

}
